import axiosInstance from "../../../common/axiosInstance";

/**
 * ============================================================
 * CREATE WORKSPACE
 * POST /projects/{projectUuid}/workspaces
 * ============================================================
 */
export const createWorkspace = async (
  projectUuid,
  workspaceData
) => {
  try {
    const response = await axiosInstance.post(
      `/projects/${projectUuid}/workspaces`,
      workspaceData
    );

    return response.data;
  } catch (error) {
    console.error(
      "CREATE WORKSPACE ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * GET WORKSPACES
 * GET /projects/{projectUuid}/workspaces
 * ============================================================
 */
export const getWorkspaces = async (projectUuid) => {
  try {
    const response = await axiosInstance.get(
      `/projects/${projectUuid}/workspaces`
    );

    return response.data;
  } catch (error) {
    console.error(
      "GET WORKSPACES ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * GET WORKSPACE MEMBERS
 * GET /workspaces/{workspaceUuid}/members
 * ============================================================
 */
export const getWorkspaceMembers = async (
  workspaceUuid
) => {
  try {
    const response = await axiosInstance.get(
      `/workspaces/${workspaceUuid}/members`
    );

    return response.data;
  } catch (error) {
    console.error(
      "GET WORKSPACE MEMBERS ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * ADD MEMBER TO WORKSPACE
 * POST /workspaces/{workspaceUuid}/members
 * ============================================================
 */
export const addWorkspaceMember = async (
  workspaceUuid,
  memberData
) => {
  try {
    const response = await axiosInstance.post(
      `/workspaces/${workspaceUuid}/members`,
      memberData
    );

    return response.data;
  } catch (error) {
    console.error(
      "ADD WORKSPACE MEMBER ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * CREATE WORKSPACE ITEM
 * POST /workspaces/{workspaceUuid}/items
 * ============================================================
 */
export const createWorkspaceItem = async (
  workspaceUuid,
  itemData
) => {
  try {
    const response = await axiosInstance.post(
      `/workspaces/${workspaceUuid}/items`,
      itemData
    );

    return response.data;
  } catch (error) {
    console.error(
      "CREATE ITEM ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * GET WORKSPACE ITEMS
 * GET /workspaces/{workspaceUuid}/items
 * ============================================================
 */
export const getWorkspaceItems = async (
  workspaceUuid
) => {
  try {
    const response = await axiosInstance.get(
      `/workspaces/${workspaceUuid}/items`
    );

    return response.data;
  } catch (error) {
    console.error(
      "GET ITEMS ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * GET WORKSPACE DETAILS
 * GET /projects/{projectUuid}/workspaces/{workspaceUuid}
 * ============================================================
 */
export const getWorkspaceDetails = async (
  projectUuid,
  workspaceUuid
) => {
  try {
    const response = await axiosInstance.get(
      `/projects/${projectUuid}/workspaces/${workspaceUuid}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "GET WORKSPACE DETAILS ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};

/**
 * ============================================================
 * UPDATE WORKSPACE
 * PUT /projects/{projectUuid}/workspaces/{workspaceUuid}
 * ============================================================
 */
export const updateWorkspace = async (
  projectUuid,
  workspaceUuid,
  workspaceData
) => {
  try {
    const response = await axiosInstance.put(
      `/projects/${projectUuid}/workspaces/${workspaceUuid}`,
      workspaceData
    );

    return response.data;
  } catch (error) {
    console.error(
      "UPDATE WORKSPACE ERROR:",
      error.response?.data || error
    );

    throw error;
  }
};